<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Información de la orden</h1>
		<div class="information" v-if="order">
			<p v-if="order.id" class="information__text"><strong class="information__text--strong">Id de orden: </strong>{{ order.id }}</p>
			<p v-if="order.user_id" class="information__text"><strong class="information__text--strong">Id de usuario: </strong>{{ order.user_id }}</p>
			<p v-if="order.date_created" class="information__text"><strong class="information__text--strong">Fecha de creación: </strong>{{ order.date_created | longDate }}</p>
			<p v-if="order.date_updated" class="information__text"><strong class="information__text--strong">Fecha de actualización: </strong>{{ order.date_updated | longDate }}</p>
			<p v-if="order.guest_user" class="information__text"><strong class="information__text--strong">Tipo de usuario: </strong>{{ isNaN(order.user_id) ? 'Usuario no registrado' : 'Cliente Registrado' }}</p>
		</div>
		<div class="results" v-if="products">
			<h2 class="content__subtitle">Productos</h2>
			<div class="results__element" v-for="(product, index) in products" :key="index">
				<div class="results__info">
					<h2 class="results__title">Id de Producto: {{ product.item_id }}</h2>
					<p class="results__text">Título: {{ product.title_es }}</p>
					<p class="results__text">Color: {{ product.color_es }}</p>
					<p class="results__text">Tamaño: {{ product.size_es }}</p>
					<p class="results__text">Cantidad: {{ product.quantity }}</p>
					<p class="results__text">Precio: {{ product.price | price }}</p>
				</div>
				<div class="results__actions">
					<router-link :to="{ name: 'productView' }" @click.prevent="$parent.$emit('view', product.user_id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">
						Ir al producto
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		order: {
			type: Object
		}
	},
	computed: {
		products: function() {
			return this.order.products
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/orders/view.vue